import {connect} from 'react-redux';

import {deleteCardGroupsAsyncAction} from '../../../../../../../../../../src/store/data/cardGroups/cardGroupsActions';
import {makeGetSelectedCardGroupIds} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {contactsManagerTableForceRefreshAction} from '../../../../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {ContactsManagerPanelId} from '../../../../../../../../../../src/store/panels/panelStateBase';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../../../../srcCommon/helpers/reselectHelpers';
import {CardGroupsTableMultiDeleteAction} from './cardGroupsTableMultiDeleteAction';

/*
 * Props.
 */

interface CardGroupsTableMultiDeleteActionContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CardGroupsTableMultiDeleteActionContainerProps>()(() => ({
  cardGroupIds: makeGetSelectedCardGroupIds(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onDeleteCardGroupsAsync: deleteCardGroupsAsyncAction,
  onForceRefresh: contactsManagerTableForceRefreshAction,
}));

export const CardGroupsTableMultiDeleteActionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CardGroupsTableMultiDeleteAction);
